import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography, Button, Container } from "@mui/material";
import logo from "../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import ArrowBtn from "./ArrowBtn";
import { API_BASE_URL } from "./Config";
import axios from "axios";
import { useSnackbar } from "notistack";

const Footer = () => {
  const { enqueueSnackbar } = useSnackbar();

  const location = useLocation();
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!validateEmail(email)) {
      enqueueSnackbar("Please enter a valid email address", {
        variant: "error",
      });
      return;
    }
    try {
      const data = { email };
      const res = await axios.post(`${API_BASE_URL}/accounts/subscribe/`, data);
      setEmail("");
      enqueueSnackbar(res.data.message, { variant: "success" });
      console.log(res);
    } catch (error) {
      console.error(error);
      if (error?.response?.data?.message) {
        enqueueSnackbar(error?.response?.data?.message, { variant: "error" });
      } else {
        enqueueSnackbar("Subscription failed. Please try again later.", {
          variant: "error",
        });
      }
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <>
      <footer>
        <div className="arrow_icons_home">
          <ArrowBtn />
        </div>
        {/* <div className='arrow_icons_footer'>
          <ArrowBtn />
        </div> */}
        <Container maxWidth="xl">
          <Box sx={{ mb: "30px" }}>
            <img src={logo} alt="" width={"200px"} />
          </Box>

          <Box className="mainFoter">
            <Box className="contentDiv foter_div1">
              <Box>
                <Typography variant="subtitle2" className="FOTER_DESC">
                  WeCare is a trading name of WeCare <br />
                  Boiler Repair Ltd, registered in England &<br /> Wales. Reg
                  No: 15125992.
                </Typography>
                <Box mt={1} className="foter_input">
                  <p
                    className="footer_input_heading"
                    style={{ marginBottom: "5px", fontWeight: "700" }}
                  >
                    {" "}
                    Subscribe{" "}
                  </p>
                  <div className="fotIn_div">
                    <input
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      className="btnFooter"
                      onClick={handleSubscribe}
                    >
                      Send
                    </Button>
                  </div>
                </Box>
              </Box>
            </Box>
            <div className="footer_content_div">
              <div className="footer_div2">
                <Box className="contentDiv">
                  <Typography variant="body1" className="fotertitle">
                    Social
                  </Typography>

                  <Link className="linktag">
                    <div class="navResponsiveAccordianItem">Facebook</div>
                  </Link>
                  <Link className="linktag">
                    <div class="navResponsiveAccordianItem">Instagram</div>
                  </Link>
                  <Link className="linktag">
                    <div class="navResponsiveAccordianItem">Linkedin</div>
                  </Link>
                  <Link className="linktag">
                    <div class="navResponsiveAccordianItem"></div>X
                  </Link>
                </Box>
                <Box className="contentDiv">
                  <Typography variant="body1" className="fotertitle">
                    WeCare
                  </Typography>

                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">Home</div>
                  </NavLink>

                  <NavLink
                    to="/About"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">About</div>
                  </NavLink>

                  <NavLink
                    to="/Contect"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">Contact</div>
                  </NavLink>

                  <NavLink
                    to="/Terms"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">
                      Terms & Conditions
                    </div>
                  </NavLink>

                  <NavLink
                    to="/Complaints"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">
                      Complaints Procedure
                    </div>
                  </NavLink>

                  <NavLink
                    to="/Privacy"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">
                      Privacy Policy
                    </div>
                  </NavLink>

                  <NavLink
                    to="/Cookies"
                    className={({ isActive }) =>
                      isActive ? "active" : "linktag"
                    }
                  >
                    <div className="navResponsiveAccordianItem">
                      Cookie Policy
                    </div>
                  </NavLink>
                </Box>
              </div>

              <div className="footer_div3">
                <Box className="contentDiv">
                  <Typography variant="body1" className="fotertitle">
                    Services
                  </Typography>

                  <Link
                    to="/"
                    onClick={() =>
                      setTimeout(() => {
                        
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div className="navResponsiveAccordianItem">Boiler</div>
                  </Link>

                  <Link
                    to="/"
                    onClick={() =>
                      setTimeout(() => {
                        
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div className="navResponsiveAccordianItem">Boiler+</div>
                  </Link>

                  <Link
                    to="/"
                    onClick={() =>
                      setTimeout(() => {
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div className="navResponsiveAccordianItem">Heating+</div>
                  </Link>

                  <Link
                    to="/"
                    onClick={() =>
                      setTimeout(() => {
                        
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div className="navResponsiveAccordianItem">Home+</div>
                  </Link>
                </Box>

                <Box className="contentDiv">
                  <Typography variant="body1" className="fotertitle">
                    Help & Advice
                  </Typography>
                  <Link
                    to="/"
                    className={
                      location.pathname === "/Help" ? "active" : "linktag"
                    }
                  >
                    <div class="navResponsiveAccordianItem">FAQS</div>
                  </Link>
                  <Link
                    to="/Help"
                    onClick={() =>
                      setTimeout(() => {
                        
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div class="navResponsiveAccordianItem">
                      What is Boiler Cover?
                    </div>
                  </Link>
                  <Link
                    to="/#"
                    onClick={() =>
                      setTimeout(() => {
                        
                      }, 500)
                    }
                    className={"linktag"}
                  >
                    <div class="navResponsiveAccordianItem">
                      What is Home Cover?
                    </div>
                  </Link>
                </Box>
              </div>
            </div>
          </Box>
          <Typography variant="body1" className="wecare_2023 copy_rights">
            © 2024, WeCare Boiler Repair Ltd
          </Typography>
          {/* <p className='wecare_2023'>
            © 2024, W eCare Boiler Repair Ltd
          </p> */}
        </Container>
      </footer>
    </>
  );
};

export default Footer;
